import React from 'react';

export const liveRoute = [
  {
    path: '/live/home',
    component: React.lazy(() => import('@/views/Live/recommend')),
    meta: {
      title: '推荐'
    }
  },
  {
    path: '/live/allLive',
    component: React.lazy(() => import('@/views/Live/allLive')),
    meta: {
      title: '全部'
    }
  },
  {
    path: '/live/follow',
    component: React.lazy(() => import('@/views/Live/follow')),
    meta: {
      title: '关注'
    }
  },
  {
    path: '/live/studio',
    component: React.lazy(() => import('@/views/Live/studio')),
    meta: {
      title: '直播间'
    }
  },
  {
    path: '/live/search',
    component: React.lazy(() => import('@/views/Live/layout/components/liveSearch')),
    meta: {
      title: '搜索页'
    }
  },
  {
    path: '/live/liveRelated',
    component: React.lazy(() => import('@/views/Live/liveRelated/index')),
    meta: {
      title: '主播中心'
    }
  },
  {
    path: '/live/alipayWithdraw',
    component: React.lazy(() => import('@/views/Live/liveWithdraw/alipayWithdraw/index')),
    meta: {
      title: '支付宝提现'
    }
  },
  {
    path: '/live/unionpayWithdraw',
    component: React.lazy(() => import('@/views/Live/liveWithdraw/unionpayWithdraw/index')),
    meta: {
      title: '银行卡提现'
    }
  },
  {
    path: '/live/studio/goldenBean',
    component: React.lazy(() => import('@/views/Live/studio/livePlay/treasureBox/goldenBean')),
    meta: {
      title: '金豆充值'
    }
  }
];
